export const actionTypes = {
  // get
  GET_GOLD_RATE_CATEGORY_START: 'GET_GOLD_RATE_CATEGORY_START',
  GET_GOLD_RATE_CATEGORY_SUCCESS: 'GET_GOLD_RATE_CATEGORY_SUCCESS',
  GET_GOLD_RATE_CATEGORY_FINISH: 'GET_GOLD_RATE_CATEGORY_FINISH',
}
